export default __webpack_public_path__ + "static/media/service.67717712.bcb75c94.svg";